
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"120","height":"120"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M90.53 94.83V61.35a30.53 30.53 0 00-61.06 0v33.48","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M51.35 32.67v-3.11a8.65 8.65 0 1117.3 0v3.11M66.8 106.11a6.8 6.8 0 01-13.6 0M90.53 95.32l10.34 10.34H19.13l10.34-10.34h61.06z","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M55.63 64.29v14.09l8.08 8.2v8.98l9.97 9.96M36.08 42.44h47.84"}})])
          )
        }
      }
    